// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wtv-tour-detail-content ul{padding:0;margin:0;list-style-type:none}.wtv-tour-detail-content ul li:before{content:\"\";display:inline-flex;width:8px;height:8px;border-radius:2px;background-color:var(--color-bg-dark);margin-right:8px}", ""]);
// Exports
module.exports = exports;
